import {FC} from 'react';

import {PriceWithUsd} from 'components/currency/price-with-usd';
import {MinimalQuotedPaymentMethodFragment} from 'generated/graphql';
import {calculatePaymentMethodTotalPrice, QuotedProductPriceFields} from 'utils/quotes/calculator';

interface PaymentMethodTotalPriceProps {
    products: QuotedProductPriceFields[];
    paymentMethod: Omit<MinimalQuotedPaymentMethodFragment, 'originalPaymentMethod'>;
    dealer?: boolean;
    exchangeRate?: number | null;
};

export const PaymentMethodTotalPrice: FC<PaymentMethodTotalPriceProps> = ({
    products,
    paymentMethod,
    dealer = false,
    exchangeRate,
}) => {
    const price = calculatePaymentMethodTotalPrice(products, paymentMethod, undefined, dealer);
    return <PriceWithUsd brlAmount={price} exchangeRate={exchangeRate} />;
};
